import {translation} from "@2d-front-monorepo/core";
import {BackButton} from "@2d-front-monorepo/design-library";
import {JSX} from "react";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import MaterialIcon from "./MaterialIcon";

export type PermitsBackButtonProps = {
	label?: string,
	small?: boolean,
	href?: string
}

export function PermitsBackButton(props: PermitsBackButtonProps): JSX.Element {
	const {small, href, label} = props;
	return <BackButton small={small ?? false} href={href}><MaterialIcon icon="arrow_back"/>{translation(label ?? PermitTranslations.back)}</BackButton>;
}

export function PermitsBackButtonFrame(props: PermitsBackButtonProps): JSX.Element {
	const {href, label} = props;
	return <div className="form__buttons form__buttons--bottom form__buttons--center">
		<PermitsBackButton small={true} href={href} label={label}/>
	</div>;
}
